import {PreviewFormValues} from 'components/customer/Preview3D/types';

export const generateDrillingPositions = (values: PreviewFormValues) => {
    const {drillings} = values;
    return {
        positions: drillings?.flatMap((drilling) => {
            const result = [];
            if (
                drilling.drilling_offset_y > 0 &&
                drilling.drilling_offset_x > 0 &&
                drilling.drilling_num_holes > 0
            ) {
                for (let i = 0; i < drilling.drilling_num_holes; i++) {
                    const gap = Number(drilling.drilling_pitch) * i;
                    // swapping x & y as it seems opposite when we are displaying them in drilling tab
                    const x = Number(drilling.drilling_offset_y) + gap;
                    const y = Number(drilling.drilling_offset_x);
                    result.push({
                        x,
                        y,
                    });
                }
            }
            return result;
        }),
    };
};
